import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { useToken } from 'src/features/auth/api/useToken';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';
import { protectedRoutes } from 'src/routes/protected';
import { publicRoutes } from 'src/routes/public';
import { useZodCustomErrorMap } from 'src/utils/errors';
import AuthContext from 'src/features/auth/context/AuthContext';
import React from 'react';

export const AppRoutes = () => {
    useZodCustomErrorMap();

    const { data, isPending } = useToken();
    const { permissionsLoaded } = React.useContext(AuthContext);

    // TODO uncomment when login is implemented
    const isAuthenticated = Boolean(data);

    // A data router owns the history stack, so it is built once per auth state rather than on every
    // render. Signing in or out is a full context switch, so rebuilding the router there is
    // intended; anything finer would discard history on unrelated re-renders.
    const router = React.useMemo(
        () => createBrowserRouter(isAuthenticated ? protectedRoutes : publicRoutes),
        [isAuthenticated],
    );

    if (isPending || !permissionsLoaded) return <FallbackBlock />;
    return <RouterProvider router={router} />;
};
